const faqItems = [
  {
    q: '老子影视网的视频清晰度怎么样？',
    a: '平台所有高清电影、高清电视剧均提供超清画质播放，支持4K分辨率。采用先进的视频编码技术，确保画面细腻、色彩饱满，同时实现不缓冲秒开的流畅体验。',
  },
  {
    q: '需要注册或付费才能观看吗？',
    a: '不需要。老子影视网坚持免费在线观看，所有高清视频资源均无需注册登录，打开网站即可直接全集播放，没有任何隐藏收费。',
  },
  {
    q: '更新频率如何？新剧什么时候上线？',
    a: '我们保持7×24小时持续更新，热播剧集通常在播出后数小时内上线。院线电影下映后也会尽快收录高清版本，你可以关注"最新更新"模块获取实时动态。',
  },
  {
    q: '支持哪些设备观看？画质会自动调整吗？',
    a: '老子影视网全面适配桌面端、平板和手机浏览器。移动端同样支持超清画质，系统会根据网络状况智能优化，无论使用什么设备都能获得最佳观影体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-500">关于老子影视网，你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.q}
              className="bg-background-50 rounded-lg border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-5">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}